import { Component, OnInit, ElementRef, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';

import { SchedulesSearchService } from './schedules-search.service';
import { DatePicker } from './../../shared/date-picker';
import { LogService, Port, AppContext } from './../../shared';
import { last } from '@angular/router/src/utils/collection';

declare const moment: any;

@Component({
  selector: 'schedules-search',
  template: require('./schedules-search.component.html'), 
  styles: [require('./schedules-search.component.scss')],
  providers: [SchedulesSearchService],
  host: {
    '(document:click)': 'onClick($event)'
  }
})
export class SchedulesSearchComponent implements OnInit {
  @Output() close: EventEmitter<any> = new EventEmitter();

  private originTermStream: Subject<any> = new Subject<any>();
  originTerm: string = '';
  origin: any = null;
  originPorts = Array<Port>();
  originLocations = Array<any>();
  originPortSub: any;
  originLocationSub: any;
  originNoResult: boolean = false;
  originNearPorts: boolean = true;

  private destinationTermStream: Subject<any> = new Subject<any>();
  destinationTerm: string = '';
  destination: any = null;
  destinationPorts = Array<Port>();
  destinationLocations = Array<any>();
  destinationPortSub: any;
  destinationLocationSub: any;
  destinationNoResult: boolean = false;
  destinationNearPorts: boolean = true;

  date: string;
  arrival: boolean = false;
  week: number = 2;
  da: string = 'depart';
  showRoutes: boolean = false;
  originResults: any;
  destinationResults: any;

  constructor(private router: Router, private logger: LogService, private service: SchedulesSearchService, private ref: ElementRef, private app: AppContext ) {
    // Do stuff
  }

  ngOnInit() {

    this.loadCache();
    this.initOrigin();
    this.initDestination();
    this.initNearBy();
    this.initDepartArrive();

    var appStatus = this.app;

    if (sessionStorage.getItem('need-update-search-setting') !== 'false') {
      if(this.app.accountType === "Professional") {
        this.week = 8;
        this.destinationNearPorts = true;
        this.originNearPorts = true;

        sessionStorage.setItem('schedules-week', '8');
        sessionStorage.setItem('schedules-origin-nearby', 'ture');
        sessionStorage.setItem('schedules-destination-nearby', 'true');

        sessionStorage.setItem('need-update-search-setting', 'false');
      }
  
      if(this.app.accountType === "Premium") {
        console.log('Premium User')
        this.week = 6;
          // if box checked originNearPorts/destinationNearPorts = true if not originNearPorts = false
        this.destinationNearPorts = true;
        this.originNearPorts = true;

        sessionStorage.setItem('schedules-week', '6');
        sessionStorage.setItem('schedules-origin-nearby', 'ture');
        sessionStorage.setItem('schedules-destination-nearby', 'true');

        sessionStorage.setItem('need-update-search-setting', 'false');
      }
  
      if(this.app.accountType === "Basic") {
        this.week = 4;
        this.destinationNearPorts = false;
        this.originNearPorts = false;

        sessionStorage.setItem('schedules-week', '4');
        sessionStorage.setItem('schedules-origin-nearby', 'false');
        sessionStorage.setItem('schedules-destination-nearby', 'false');

        sessionStorage.setItem('need-update-search-setting', 'false');
      }
  
      // if(this.app.accountType === "") {
      //   this.week = 2;
      //   this.destinationNearPorts = false;
      //   this.originNearPorts = false;
      //   sessionStorage.setItem('need-update-search-setting', 'true');
      // }
    }

    if (this.app.accountType === "") {
      this.week = 2;
      this.destinationNearPorts = false;
      this.originNearPorts = false;

      sessionStorage.setItem('need-update-search-setting', 'true');
      sessionStorage.setItem('schedules-week', '2');
      sessionStorage.setItem('schedules-origin-nearby', 'false');
      sessionStorage.setItem('schedules-destination-nearby', 'false');
    }
  }

  accountValueChange() {
    if (this.app.accountType === 'Premium') {
      this.week = 6;
      console.log('Premium User ngModel');
    }
  }

  loadCache(): void {
    this.originTerm = sessionStorage.getItem('schedules-origin-title');
    this.origin = JSON.parse(sessionStorage.getItem('schedules-origin'));

    this.destinationTerm = sessionStorage.getItem('schedules-destination-title');
    this.destination = JSON.parse(sessionStorage.getItem('schedules-destination'));

    this.originNearPorts = sessionStorage.getItem('schedules-origin-nearby') == 'true';
    this.destinationNearPorts = sessionStorage.getItem('schedules-destination-nearby') == 'true';

    if (sessionStorage.getItem('schedules-date')) {
      this.date = sessionStorage.getItem('schedules-date');
    }
    this.da = sessionStorage.getItem('schedules-depart-arrive');
    if (this.da !== 'arrive') {
      this.da = 'depart';
    }

    var lastWeek = +sessionStorage.getItem('schedules-week');
    if (lastWeek == 1 || lastWeek == 2 || lastWeek == 3 || lastWeek == 4 || 
      lastWeek == 5 || lastWeek == 6 || lastWeek == 7 || lastWeek == 8) {
        this.week = lastWeek;
    }

    // if(this.app.accountType === "") {
    //   this.week = 2;
    //   this.destinationNearPorts = false;
    //   this.originNearPorts = false;

    //   sessionStorage.setItem('schedules-week', this.week.toString());
    //   sessionStorage.setItem('schedules-origin-nearby', this.originNearPorts.toString());
    //   sessionStorage.setItem('schedules-destination-nearby', this.destinationNearPorts.toString());
    //   sessionStorage.setItem('need-update-search-setting', 'true');
    // } else {
    //   if (sessionStorage.getItem('need-update-search-setting') === 'true') {
    //     sessionStorage.setItem('need-update-search-setting', 'false');
    //     if(this.app.accountType === "Professional") {
    //       this.week = 8;
    //       sessionStorage.setItem('schedules-week', '8');
    //     }
    
    //     if(this.app.accountType === "Premium") {
    //       console.log('Premium User')
    //       this.week = 6;
    //       sessionStorage.setItem('schedules-week', '6');
    //     }
    
    //     if(this.app.accountType === "Basic") {
    //       this.week = 4;
    //       sessionStorage.setItem('schedules-week', '4');
    //     }
    //   }
    // }
  }

  initOrigin() {
    this.originResults = this.ref.nativeElement.querySelector('originResults');

    this.originPortSub = this.originTermStream
      .debounceTime(100)
      .distinctUntilChanged()
      .switchMap((term: string) => this.service.getPorts('origin', term)).subscribe((ports: Array<Port>) => {
        this.originPorts = ports;
        this.originNoResult = (this.service.originPortNoResult && this.service.originLocationNoResult
          && !this.service.originLoaderOn) ? true : false;
      });

    this.originLocationSub = this.originTermStream
      .debounceTime(100)
      .distinctUntilChanged()
      .switchMap((term: string) => this.service.getLocations('origin', term)).subscribe(locations => {
        this.originLocations = locations;
        this.originNoResult = (this.service.originPortNoResult && this.service.originLocationNoResult
          && !this.service.originLoaderOn) ? true : false;
      });
  }

  initDestination() {
    this.destinationResults = this.ref.nativeElement.querySelector('destinationResults');

    this.destinationPortSub = this.destinationTermStream
      .debounceTime(100)
      .distinctUntilChanged()
      .switchMap((term: string) => this.service.getPorts('destination', term)).subscribe((ports: Array<Port>) => {
        this.destinationPorts = ports;
        this.destinationNoResult = (this.service.destinationPortNoResult && this.service.destinationLocationNoResult
          && !this.service.destinationLoaderOn) ? true : false;
      });

    this.destinationLocationSub = this.destinationTermStream
      .debounceTime(100)
      .distinctUntilChanged()
      .switchMap((term: string) => this.service.getLocations('destination', term)).subscribe(locations => {
        this.destinationLocations = locations;
        this.destinationNoResult = (this.service.destinationPortNoResult && this.service.destinationLocationNoResult
          && !this.service.destinationLoaderOn) ? true : false;
      });
  }

  initNearBy() {
    var originCheck = <HTMLInputElement> document.getElementById("origin-ports-selection");
    originCheck.checked = this.originNearPorts;
    var destinationCheck = <HTMLInputElement> document.getElementById("destination-ports-selection");
    destinationCheck.checked = this.destinationNearPorts;
  }

  initDepartArrive() {
    var departRadio = <HTMLInputElement> document.getElementById("depart-radio");
    var arriveRadio = <HTMLInputElement> document.getElementById("arrive-radio");
    if (this.da === 'depart') {
      departRadio.checked = true;
      arriveRadio.checked = false;
    } else {
      departRadio.checked = false;
      arriveRadio.checked = true;
    } 
  }

  originClick($event) {
    this.originAuto();
    this.service.originAutoOn = true;
    $event.target.select();
  }

  destinationClick($event) {
    this.destinationAuto();
    this.service.destinationAutoOn = true;
    $event.target.select();
  }

  onClick($event) {
    if ($event.target.id === 'origin' && !this.service.originAutoOn) {
      // this.service.originAutoOn = true;
      this.originAuto();
    } else if (($event.target.id !== 'origin' && this.service.originAutoOn)) {
      this.service.originAutoOn = false;
    }

    if ($event.target.id === 'destination' && !this.service.destinationAutoOn) {
      // this.service.destinationAutoOn = true;
      this.destinationAuto();
    } else if (($event.target.id !== 'destination' && this.service.destinationAutoOn)) {
      this.service.destinationAutoOn = false;
    }
    // if (($event.target.id !== 'destination' && $event.target.contains(this.destinationResults)) && this.service.destinationAutoOn) {
  }

  search() {
    if (this.origin == null || this.destination == null) {
      return;
    }

    sessionStorage.setItem('schedules-origin-title', this.originTerm);
    sessionStorage.setItem('schedules-origin', JSON.stringify(this.origin));

    sessionStorage.setItem('schedules-destination-title', this.destinationTerm);
    sessionStorage.setItem('schedules-destination', JSON.stringify(this.destination));

    sessionStorage.setItem('schedules-origin-nearby', this.originNearPorts.toString());
    sessionStorage.setItem('schedules-destination-nearby', this.destinationNearPorts.toString());

    sessionStorage.setItem('schedules-date', this.date);
    sessionStorage.setItem('schedules-depart-arrive', this.da);

    sessionStorage.setItem('schedules-week', this.week.toString());

    let params = this.setRouteParams();
    
    this.close.emit({ event: event, searchType: '' });

    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
      this.router.navigate(['/schedules', params]));
  }

  setRouteParams(): any {
    let params = {
      origin_search: this.originTerm,
      destination_search: this.destinationTerm,
    };
    this.setRouteDate(params);
    this.setOriginAndDestination(params);

    return params;
  }

  setRouteDate(params) {
    // let date = moment(this.date).format('YYYY-MM-DD');
    let endDate = moment(this.date, 'YYYY-MM-DD').add(this.week, 'week').format('YYYY-MM-DD');

    let startDate = encodeURIComponent(this.date);
    endDate = encodeURIComponent(endDate);

    if (this.da === 'depart') {
      params['start_date_gte'] = startDate;
      params['start_date_lte'] = endDate;
    } else {
      params['end_date_gte'] = startDate;
      params['end_date_lte'] = endDate;
    }
  }

  setOriginAndDestination(params) {

    params['origin_id'] = this.origin.id;
    //params['with_nearby_origins'] = this.originNearPorts;
    if (this.originNearPorts === true) {
      params['with_nearby_origins'] = 'true';
    } else {
      params['with_nearby_origins'] = 'false';
    }

    try {
      params['origin_type'] = this.origin.type || 'port';
    } catch (ex) {
      params['origin_type'] = 'port';
    }

    params['destination_id'] = this.destination.id;
    //params['with_nearby_destinations'] = 'false';this.destinationNearPorts;
    if (this.destinationNearPorts === true) {
      params['with_nearby_destinations'] = 'true';
    } else {
      params['with_nearby_destinations'] = 'false';
    }

    try {
      params['destination_type'] = this.destination.type || 'port';
    } catch (ex) {
      params['destination_type'] = 'port';
    }
  }

  setOriginPort(item) {
    this.service.originAutoOn = false;
    this.originTerm = item.title;
    this.origin = item;
  }

  setOriginLocation(item) {
    this.service.originAutoOn = false;
    this.originTerm = item.value.name;
    this.origin = item;
    // this.service.getPortsForLocation(item).then((result) => {
    //   this.origin = result;
    // });
  }

  setDestinationPort(item) {
    this.service.destinationAutoOn = false;
    this.destinationTerm = item.title;
    this.destination = item;
  }

  setDestinationLocation(item) {
    this.service.destinationAutoOn = false;
    this.destinationTerm = item.value.name;
    // this.service.getPortsForLocation(item).then((result) => {
    //   this.destination = result;
    // });
    this.destination = item;
  }

  originAuto(event: KeyboardEvent = null) {
    if (event != null) {
      this.capture('origin', event.keyCode);
    }

    if (this.originTerm != null && this.originTerm.length < 3) {
      // clear results
      this.service.endPortSearch(true, 'origin');
      this.service.endLocationSearch(true, 'origin');

      if (this.service.app.ports.length === 0) {
        this.service.originAutoOn = false;
      } else {
        this.service.originAutoOn = true;
        this.service.destinationAutoOn = false;
      }
    } else if (this.originTerm != null) {
      this.originTermStream.next(this.originTerm);
      if (!this.service.originLoaderOn && this.service.originPortNoResult && this.service.originLocationNoResult) {
        this.service.originAutoOn = false;
      }
    }
  }

  destinationAuto(event: KeyboardEvent = null) {
    if (event != null) {
      this.capture('destination', event.keyCode);
    }
    if (this.destinationTerm != null && this.destinationTerm.length < 3) {
      // clear results
      this.service.endPortSearch(true, 'destination');
      this.service.endLocationSearch(true, 'destination');

      if (this.service.app.ports.length === 0) {
        this.service.destinationAutoOn = false;
      } else {
        this.service.destinationAutoOn = true;
        this.service.originAutoOn = false;
      }
    } else if (this.destinationTerm != null){
      this.destinationTermStream.next(this.destinationTerm);

      if (!this.service.destinationLoaderOn && this.service.destinationPortNoResult && this.service.destinationLocationNoResult) {
        this.service.destinationAutoOn = false;
      }
    }
  }

  capture(input: string, keyCode: number) {
    switch (keyCode) {
      case 9:
        this.autocomplete(input);
        break;
      case 13:
        this.autocomplete(input);
        if (input == 'destination') {
          this.search();
        }
        break;
      case 35:
        this.highlight('up');
        break;
      case 40:
        this.highlight('down');
        break;
    }
  }

  autocomplete(inbox: string) {
    try {
      if (inbox == 'destination') {
        if (this.destinationPorts != null && this.destinationPorts.length > 0) {
          this.setDestinationPort(this.destinationPorts[0]);
        } else {
          this.setDestinationLocation(this.destinationLocations[0]);
        }
        this.service.destinationAutoOn = false;
      } else if (inbox == 'origin') {
        if (this.originPorts != null && this.originPorts.length > 0) {
          this.setOriginPort(this.originPorts[0]);
        } else {
          this.setOriginLocation(this.originLocations[0]);
        }
        this.service.originAutoOn = false;
      } else {
        this.logger.log('schedules-search', 'autocomplete unknown inbox:', inbox);
      }
    } catch (ex) {
      this.logger.log('schedules-search', 'autocomplete ex', ex);
    }
  }

  highlight(direction: string = 'down') {
    // expand to highlight items in the list
  }

  when(checked: string) {
    this.da = checked;
  }

  toggleRoutes() {
    if (this.service.app.accountType === '') {
      this.service.app.showRegister();
    } else if (this.service.app.routes.length !== 0) {
      this.showRoutes = !this.showRoutes;
    } else {
      this.showRoutes = false;
      this.service.app.showSavedRoutesExplanation();
    }
  }

  toggleNearbyPorts() {
    if (this.service.app.accountType === '') {
      // const inputField = document.getElementById("test")
      var element = <HTMLInputElement> document.getElementById("destination-ports-selection");
      var originCheck = <HTMLInputElement> document.getElementById("origin-ports-selection");
      element.checked = false;
      originCheck.checked = false;
      this.service.app.showRegister();
    }
    if (this.service.app.accountType === 'Basic') {
      var element = <HTMLInputElement> document.getElementById("destination-ports-selection");
      var originCheck = <HTMLInputElement> document.getElementById("origin-ports-selection");
      element.checked = false;
      originCheck.checked = false;
      this.service.app.showUpgrade();
  }
}

  populateRoute(route: any) {
    this.showRoutes = false;

    let originName: string = route.originName;
    originName = originName.substr(0, originName.indexOf('['));
    let routeOrigin = {
      id: route.originId,
      title: originName
    };
    this.setOriginPort(routeOrigin);

    let destinationName: string = route.destinationName;
    destinationName = destinationName.substr(0, destinationName.indexOf('['));
    let routeDestination = {
      id: route.destinationId,
      title: destinationName
    };
    this.setDestinationPort(routeDestination);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/search/schedules-search/schedules-search.component.ts